import React,{useState} from "react";
import { PortfolioBottomButton, PortfolioCardComponent } from "../../SecondComponents";
import img from "../../secondAssets/Images/modernTitle8.jpeg";

const PortfolioCard8 = (props) => {
    const { selectedLanguage } = props;
    return (
        <div className="main">
            <div className="second-design-service-container">
                <div className="service-top-div">
                    <div>
                        <h1>{selectedLanguage?.txt_no_cnn_is_made_of_advertising}</h1>
                    </div>
                </div>
                <div>
                    <PortfolioCardComponent name={selectedLanguage?.txt_invisalign} heading={selectedLanguage?.txt_no_cnn_is_made_of_advertising} img={img}/>
                    <PortfolioBottomButton {...props}/>
                </div>
            </div>
        </div>
    )
}

export default PortfolioCard8